import styles from './AboutPage.module.scss';
import React, { useEffect, useState } from 'react';
import { useWindowSize } from '../../../utils/useWindowSize';
import { getPlatform } from '../../../utils/defineUserPlatform';
import PageContainer from '../../../components/layout/PageContainer';
import Header from '../../../components/layout/Header';
import VideoBg from '../../../components/layout/VideoBg';
import { SectionSelector } from './SectionSelector';
import { VerticalNavigation } from './verticalNavigation/VerticalNavigation';
import { pageList } from './sections/sections';

const MAX_MOBILE_WIDTH = 678;
const FIRST_STEP = 0;
const LAST_STEP = 14;

export const AboutPage = () => {
  const [activeStep, setActiveStep] = useState(pageList[0].index);
  const [touchStart, setTouchStart] = useState(null);
  const [stepData, setStepData] = useState(pageList[0]);

  const windowSize = useWindowSize();
  const platform = getPlatform();

  let prevTime = new Date().getTime();

  const macintoshChangeStepOnWheel = (e, step, setStep) => {
    const curTime = new Date().getTime();
    if (typeof prevTime !== 'undefined') {
      const timeDiff = curTime - prevTime;
      if (timeDiff > 100) {
        if (e.deltaY > 0 && step < LAST_STEP) {
          setStep(step + 1);
        } else if (e.deltaY < 0 && step > FIRST_STEP) {
          setStep(step - 1);
        }
      }
    }
    prevTime = curTime;
  };

  const changeStepOnWheel = (e, step, setStep) => {
    if (e.deltaY > 0 && step < LAST_STEP) {
      setStep(step + 1);
    } else if (e.deltaY < 0 && step > FIRST_STEP) {
      setStep(step - 1);
    }
  };

  const handleOnTouchStart = (e) => {
    const start = e.changedTouches[0];
    setTouchStart(start);
  };

  const handleOnTouchEnd = (e, step, setStep) => {
    const end = e.changedTouches[0];
    if (end.screenY - touchStart.screenY < 0 && step < LAST_STEP) {
      setStep(step + 1);
    } else if (end.screenY - touchStart.screenY > 0 && step > FIRST_STEP) {
      setStep(step - 1);
    }
  };

  useEffect(() => {
    setStepData(pageList[activeStep]);
  }, [activeStep]);

  return (
    <PageContainer>
      <div
        className={styles.sectionsWrapper}
        onWheel={
          platform?.device === 'Macintosh'
            ? (e) => macintoshChangeStepOnWheel(e, activeStep, setActiveStep)
            : (e) => changeStepOnWheel(e, activeStep, setActiveStep)
        }
        onTouchStart={(e) => handleOnTouchStart(e)}
        onTouchEnd={(e) => handleOnTouchEnd(e, activeStep, setActiveStep)}
      >
        <div className={styles.headerWrapper}>
          <Header isHeaderNav isRolePage />
        </div>

        <VideoBg
          src={stepData.videoPath}
          srcImg={stepData.bgImgPath}
          isAutoPlay={windowSize.width > MAX_MOBILE_WIDTH}
        />

        <section>
          <SectionSelector currentSection={stepData.name} />
        </section>

        <VerticalNavigation
          activeStep={activeStep}
          pageList={pageList}
          onChange={(section) => setActiveStep(section)}
        />
      </div>
    </PageContainer>
  );
};
